import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'shig-unauthorized',
    templateUrl: './unauthorized.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent {}
